import { saveAs } from "file-saver";
import { PDFDocument } from "pdf-lib";

/**
 * @param dataURLs   画像 DataURL の配列
 * @param fileName   保存する PDF のファイル名
 * @param onProgress 進捗コールバック (任意)
 */
export const useImageToPdf = () => {
  const convert = async (dataURLs: string[], fileName: string, onProgress?: (done: number, total: number) => void) => {
    if (dataURLs.length === 0) return;

    const pdfDoc = await PDFDocument.create();
    const total = dataURLs.length;

    for (let i = 0; i < total; i++) {
      // ――― 画像 → Uint8Array
      const dataURL = dataURLs[i];
      const base64 = dataURL.split(",")[1];
      const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

      const img = dataURL.includes("image/png") ? await pdfDoc.embedPng(bytes) : await pdfDoc.embedJpg(bytes);

      const page = pdfDoc.addPage([img.width, img.height]);
      page.drawImage(img, { x: 0, y: 0, width: img.width, height: img.height });

      // 進捗通知
      onProgress?.(i + 1, total);

      // ★ ここで 1 フレーム待って UI に制御を返す
      await new Promise(requestAnimationFrame);
    }

    const pdfBytes = await pdfDoc.save();
    // ファイル名から改行文字を削除して安全な名前にする
    const safeFileName = fileName.replace(/[\r\n]+/g, " ").trim();
    saveAs(new Blob([pdfBytes], { type: "application/pdf" }), `${safeFileName}.pdf`);
  };

  return { convert };
};
